import { Modal, ModalProps } from '@chakra-ui/react';
import { forwardRef } from 'react';

const KS_ModalPopup = ({ children, ...rest }: ModalProps) => {
  return <Modal {...rest}>{children}</Modal>;
};

export default forwardRef(KS_ModalPopup);
